module.exports = __webpack_public_path__ + "img/snail-unicorn.78e1da39.svg";